/**
 * Determines whether client is Internet Explorer
 */
export default function isIE() {
  const userAgent = navigator.userAgent;
  // MSIE for IE10 and lower
  // Trident for IE11
  return userAgent.indexOf('MSIE ') > -1 || userAgent.indexOf('Trident/') > -1;
}
